"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.customFormat = void 0;
const customFormat = (_option, dayjsClass) => {
    dayjsClass.prototype.customFormat = function (format) {
        return this.format(this.$locale().custom[format]);
    };
};
exports.customFormat = customFormat;
